var map = {
	"./light/sport/04sportDesc/21map3.png": "o2MA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zu7S";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/sport\/04sportDesc\/21map3\.png$
// module id = zu7S
// module chunks = 0